import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { environment } from 'src/environments/environment';
import OAuthService from '../services/oauth.service';

@Directive({
  selector: '[appRoles]'
})

export class RolesDirective implements OnInit{

  constructor(
    private templateRef:TemplateRef<any>,
    private viewContainer:ViewContainerRef,
    private user : OAuthService
    ) { }

  @Input('appRoles') roles = '0'
  @Input('appRolesElse') noRol : TemplateRef<any>


  ngOnInit(): void {
    const role = this.user.getData().roleId;
    if(this.roles.includes(role)){
      this.viewContainer.createEmbeddedView(this.templateRef)
    }else if(this.noRol && !this.roles.includes(role)){
      this.viewContainer.createEmbeddedView(this.noRol)
    }
  }

}

/* Example of use:
  <div *appRoles="'1'; else appRolesNo">
    Show this div
  </div>
  <ng-template #appRolesNo>
    Show this div
  </ng-template>
*/
